exports = module.exports = require("../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".listbox[data-v-dea325dc]{width:100%;background:#fff}.listbox .city-search-item[data-v-dea325dc]{background:#fff;margin:0 10px;height:35px;line-height:35px;border-bottom:1px solid #f6f6f6;box-sizing:border-box}.listbox .city-search-item[data-v-dea325dc]:last-child{border:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader?minimize!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-dea325dc","scoped":true,"hasInlineConfig":false}!./node_modules/_stylus-loader@3.0.2@stylus-loader!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./src/packages/components/CityItem.vue
// module id = 52
// module chunks = 0